import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: #f4f4f4;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px 0;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 0 24px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 480px;
  max-width: 100%;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
  color: #595959;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #7b7b7b;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${p => (p.$warning ? '#faad14' : '#ff5b5b')};
  }
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.35;
  color: #161616;
  text-wrap: pretty;
`;

export const Message = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5em;
  text-wrap: pretty;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 4px;
`;
